<template>
  <div>
    <b-container :class="{ 'hidden': isHidden }" class="example-bar">
      <b-button variant="link" class="close" @click="hideExampleBar">
        <i class="ti ti-close" />
      </b-button>
      <b-row align-v="center">
        <b-col>
          {{ $t('component.example.text') }}
        </b-col>
        <b-col>
          <b-btn :to="{ name: 'memorial.show', params:{ id: 'demo'} }" block>{{ $t('component.example.action') }}</b-btn>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    name: 'ExampleModuleComponent',
    data() {
      return {
        isHidden: false,
      };
    },
    methods: {
      hideExampleBar() {
        this.isHidden = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@triotech/vue-core/src/scss/bootstrap';
  @import '~@triotech/vue-core/src/scss/compass';
  @import 'compass/css3/transition';

  .example-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 200;
    color: $white;

    &.container {
      background-color: $primary;
      padding: 1rem;
    }

    .btn:not(.close) {
      background-color: darken($primary, 10);
      border: 0;
      padding: 10px;

      &:hover,
      &:focus {
        box-shadow: none;
        border: 0;
        background-color: darken($primary, 20);
      }
    }

    button.close {
      display: none;
    }
  }

  @include media-breakpoint-down(xs) {
    .example-bar {
      height: auto;
      opacity: 1;

      @include transition(all .3s);

      &.container {
        padding: 25px .75rem .75rem;
        font-size: .9rem;
      }

      .btn {
        padding: 8px;
        font-size: .9rem;

        &.close {
          display: block;
          color: $white;
          padding: 4px;
          position: absolute;
          top: 0;
          right: 4px;
        }
      }

      &.hidden {
        height: 0;
        opacity: 0;
        padding: 0 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MemorialModel.vue